module.exports = __webpack_public_path__ + "media/images/bg/mosaic/origami-1fffd1c42b81d2596f0e3e713ba77d6a.svg";